import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { createApiClient } from '@apis/contracts';
import { I18nProvider } from '@apis/i18n';
import { Toaster } from '@apis/ui';
import { ApiProvider, createAppQueryClient } from './lib/api';
import { createAppRouter } from './router';
import './styles.css';

// Same origin: the Worker serves /v1 and the SPA on one port.
const api = createApiClient({ baseUrl: '' });

const queryClient = createAppQueryClient(() => {
  // Session expired mid-use: back to sign-in, keeping where the user was. `latestLocation`
  // includes a navigation in progress, so a redirect never nests another /login.
  const current = router.latestLocation;
  if (current.pathname.startsWith('/login') || current.pathname.startsWith('/menu')) return;
  void router.navigate({ to: '/login', search: { redirect: current.href }, replace: true });
});
const router = createAppRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Indonesian is the default UI language; a stored choice (ID/EN toggle) wins. */}
    <I18nProvider initialLocale="id">
      <QueryClientProvider client={queryClient}>
        <ApiProvider client={api}>
          <RouterProvider router={router} />
          <Toaster />
        </ApiProvider>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
